export class AppConfigurationNotDefinedError extends Error {
  constructor() {
    super('App configuration is not defined. Is the component inside a <AppConfigurationContext.Provider>?');
  }
}
